exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n.page__content {\n  display: flex;\n  flex-grow: 4;\n  width: 73vw;\n}\n.page__left-side {\n  width: 27vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/Page/Page.less
// module id = 875
// module chunks = 0